<template>
  <div class="integral-details" ref="container">
    <div class="header">
      <div class="currentScore">当前积分</div>
      <div>{{ info.integral }}</div>
      <div class="line"></div>
      <div class="nav acea-row">
        <div class="item">
          <div class="num">{{ info.settledIntegral || 0 }}</div>
          <div>累计积分</div>
        </div>
        <div class="item">
          <div class="num">{{ info.useIntegral || 0 }}</div>
          <div>累计消费</div>
        </div>
        <div class="item">
          <div class="num">{{ info.freezeIntegral || 0 }}</div>
          <div>冻结积分</div>
        </div>
      </div>
    </div>
    <div class="exchange">
      <input type="text" placeholder="请输入兑换码" v-model="exchangeNum" />
      <button class="exchange-btn" @click="exchange">兑换</button>
    </div>
    <div class="list">
      <div class="list-title">积分明细</div>
      <div
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in list"
        :key="index"
      >
        <div>
          <div class="state">{{ item.title }}</div>
          <div class="time">{{ item.updateTime }}</div>
        </div>
        <div class="num" v-if="item.type == 1">+{{ item.integral }}</div>
        <div class="num font-color-red" v-if="item.type == 2">
          -{{ item.integral }}
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getIntegralList, getUserIntegral } from "../../../api/user";
import { verifyTraceabilityCode } from "../../../api/code";
import Loading from "@components/Loading";
export default {
  name: "Integral",
  components: {
    Loading,
  },
  props: {},
  data: function () {
    return {
      where: {
        page: 1,
        limit: 15,
      },
      list: [],
      info: {},
      loaded: false,
      loading: false,
      exchangeNum: "",
    };
  },
  mounted: function () {
    this.getUserIntegral();
    this.getInfo();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getInfo();
    });
  },
  methods: {
    exchange: function () {
      if (!this.exchangeNum || this.exchangeNum.length === 0) {
        return this.$dialog.error("请输入兑换码");
      }
      this.$dialog.loading.open("处理中...");
      verifyTraceabilityCode(this.exchangeNum)
        .then((res) => {
          this.$dialog.loading.close();
          this.$dialog.success(res.message || "核销成功");
          this.exchangeNum = "";
          // 刷新积分数据
          this.where.page = 1;
          this.loaded = false;
          this.loading = false;
          this.list = [];
          this.getUserIntegral();
          this.getInfo();
        })
        .catch((err) => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg || "核销失败");
        });
    },
    getUserIntegral: function () {
      let that = this;
      getUserIntegral().then((res) => {
        that.info = res.data;
      });
    },
    getInfo: function () {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      getIntegralList(that.where).then(
        (res) => {
          that.loading = false;
          var list = res.data.list || [];
          that.loaded = list.length < that.where.limit;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.list.push.apply(that.list, list);
        },
        (err) => {
          that.$dialog.message(err.msg);
        }
      );
    },
  },
};
</script>
<style scoped>
.integral-details {
  padding: 0;
  min-height: 100vh;
  background: #f5f5f5;
}
.header {
  background: #e93323;
  padding: 20px 15px;
  color: #fff;
}
.currentScore {
  font-size: 14px;
  color: #fff;
  margin-bottom: 10px;
}
.header > div:nth-child(2) {
  font-size: 36px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 15px;
}
.line {
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
  margin: 15px 0;
}
.nav {
  margin-top: 10px;
}
.nav .item {
  flex: 1;
  text-align: center;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
}
.nav .item .num {
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 5px;
}
.exchange {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #fff;
  margin-top: 10px;
}
.exchange input {
  flex: 1;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
}
.exchange input:focus {
  border-color: #e93323;
}
.exchange-btn {
  width: 80px;
  height: 40px;
  background: #e93323;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;
}
.exchange-btn:active {
  background: #d32a1b;
}
.list {
  margin-top: 10px;
  background: #fff;
  padding: 15px;
}
.list-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}
.list .item {
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}
.list .item:last-child {
  border-bottom: none;
}
.list .state {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}
.list .time {
  font-size: 12px;
  color: #999;
}
.list .num {
  font-size: 16px;
  font-weight: bold;
  color: #33c334;
}
.font-color-red {
  color: #e54d42 !important;
}
</style>
